<template>
  <v-hover v-slot="{ hover }" open-delay="200">
    <v-card
      :loading="loading"
      class="mx-auto mt-5 rounded-xl"
      :class="{ 'on-hover': hover }"
      width="100%"
      :elevation="hover ? 16 : 2"
      :to="'/tickets/' + item.event._id"
      style="border-radius: 20px !important"
      @click="$router.push('/tickets/' + item.event._id).catch(() => {})"
    >
      <template slot="progress">
        <v-progress-linear
          color="deep-purple"
          height="10"
          indeterminate
        ></v-progress-linear>
      </template>
      <div class="" style="position: relative">
        <v-img
          v-if="!imageError && item.event.img"
          class="mt-3 mt-sm-0"
          style="border-top-left-radius: 20px; border-top-right-radius: 20px"
          cover
          height="250"
          :src="getImage(item.event.img)"
          @error="handleImageError"
        ></v-img>
        <div
          v-else
          class="mt-3 mt-sm-0 d-flex align-center justify-center"
          style="
            border-top-left-radius: 20px; 
            border-top-right-radius: 20px; 
            height: 250px;
            background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
          "
        >
          <i class="material-icons-round" style="font-size: 80px; color: white; opacity: 0.5;">
            image_not_supported
          </i>
        </div>
        <div
          class="border-radius-xl dark--text blur px-2 shadow-blur bg-dark theme--light"
          style="position: absolute; bottom: 15px; left: 15px; font-size: 25px"
        >
          {{ item.event.date | moment("HH:mm") }} Uhr
        </div>
        <div
          v-if="item.event.date && !isCurrentYear(item.event.date)"
          class="border-radius-xl dark--text blur px-2 shadow-blur bg-dark theme--light"
          style="position: absolute; bottom: 15px; right: 15px; font-size: 25px"
        >
          {{ getEventYear(item.event.date) }}
        </div>
      </div>

      <v-card-text>
        <v-row class="ma-0 pa-0 text-dark">
          <div style="width: 60px">
            <div class="text-h2 font-weight-bold" style="height: 40px">
              {{ item.event.date | moment("DD") }}
            </div>
            <div class="body-1 font-weight-bold text-warning">
              {{ formatMonth }}
            </div>
          </div>

          <v-col class="pa-0 ma-0">
            <div class="pl-0 mt-2">
              <div 
                class="text-h5 font-weight-bold"
                style="height: 60px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; line-height: 1.2;"
              >
                {{ item.event.title }}
              </div>
              <div class="body-1 font-weight-bold text-success">
                Deine Tickets: {{ item.participants.length }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="mx-4"></v-divider>
    </v-card>
  </v-hover>
</template>

<script>
import moment from "moment";
export default {
  name: "TicketCard",
  props: {
    item: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      loading: false,
      imageError: false,
    };
  },
  computed: {
    formatMonth() {
      if (!this.item.event || !this.item.event.date) return "";
      return moment(this.item.event.date).format("MMMM").toUpperCase().slice(0, 3);
    },
  },
  methods: {
    getImage(link) {
      return process.env.VUE_APP_API_BASEURL + "/" + link;
    },
    handleImageError() {
      this.imageError = true;
    },
    isCurrentYear(dateString) {
      if (!dateString) return true;
      const date = moment(dateString);
      const currentYear = moment().year();
      return date.year() === currentYear;
    },
    getEventYear(dateString) {
      if (!dateString) return "";
      return moment(dateString).year().toString();
    },
  },
  watch: {
    "item.event.img"() {
      // Reset error state when image changes
      this.imageError = false;
    },
  },
};
</script>

<style>
.v-card {
  transition: all 0.4s ease-in;
}
</style>
